import { KnownHubDetailsDtoType, OrderDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { DialogActions, DialogContent } from '@mui/material';
import { Alert } from '@mui/material';
import { ComponentProps } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { TextButton } from '../../../../../../ui/components/pure/text-button/text-button.component';
import { HubDetails } from '../../../../../lockers/models/hub-details.model';
import { DeliverNowModalForm } from '../delivery-action.hook';
import { useDeliveryActionStyles } from '../delivery-action.styles';
import { DeliverNowModalRecipientSummary } from './deliver-now-recipient-sumary';
import { DeliverNowModalHubSelection } from './deliver-now.hub-selection';

export function DeliverNowModalConfirmationStep(props: {
  form: UseFormReturn<DeliverNowModalForm, any, DeliverNowModalForm>;
  onAbort: () => void;
  submitHandler: (data: DeliverNowModalForm) => void;
  showHubSelection: boolean;
  showQrCodeOption: boolean;
  qrCodeWarning?: string;
  showDeliverViaCloudOption: boolean;
  onSkipToQrScan: () => void;
  skipToQrScanLabel: string;
  callToActionButtonColor: string;
  callToActionButtonLabel: string;
  selectedHub?: HubDetails;
  hubSelectOptions: { value: string; label: string; type: KnownHubDetailsDtoType }[];
  deliveryContainerSelectOptions: { value: string; label: string }[];
  subHeading?: string;
  order: OrderDto;
  showRecipientSummary: boolean;
  showBookingConfirmationAlert: boolean;
}) {
  const classes = useDeliveryActionStyles();

  return (
    <form noValidate autoComplete="off" onSubmit={props.form.handleSubmit(props.submitHandler)}>
      <DialogContent
        style={{
          marginBottom: '16px'
        }}
      >
        {props.subHeading ? <p style={{ fontWeight: 600, marginBottom: '16px' }}>{props.subHeading}</p> : null}
        {props.showBookingConfirmationAlert && (
          <Alert
            variant="outlined"
            severity="success"
            style={{
              marginBottom: '16px'
            }}
          >
            Order {props.order.orderNumber || ''} has been booked
          </Alert>
        )}
        {props.showRecipientSummary && <DeliverNowModalRecipientSummary order={props.order} />}
        <DeliverNowModalHubSelection
          form={props.form}
          selectedHub={props.selectedHub}
          showHubSelection={props.showHubSelection}
          hubSelectOptions={props.hubSelectOptions}
          deliveryContainerSelectOptions={props.deliveryContainerSelectOptions}
        />
        {props.qrCodeWarning && (
          <Alert
            variant="outlined"
            severity="warning"
            style={{
              marginTop: '16px'
            }}
          >
            {props.qrCodeWarning}
          </Alert>
        )}
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        {props.showQrCodeOption && (
          <TextButton
            className={classes.actionButton}
            onClick={props.onSkipToQrScan}
            disabled={!!props.qrCodeWarning}
            {...(props.showDeliverViaCloudOption ? secondaryButtonProps : primaryButtonProps)}
          >
            {props.skipToQrScanLabel}
          </TextButton>
        )}
        {props.showDeliverViaCloudOption && (
          <TextButton type="submit" className={classes.actionButton} {...primaryButtonProps}>
            {props.callToActionButtonLabel}
          </TextButton>
        )}
      </DialogActions>
    </form>
  );
}

const primaryButtonProps: ComponentProps<typeof TextButton> = {
  style: { color: '#ffffff', backgroundColor: '#1976d2' },
  fullWidth: true,
  color: 'primary',
  fontSize: '1rem',
  variant: 'contained'
};

const secondaryButtonProps: ComponentProps<typeof TextButton> = {
  color: 'secondary',
  variant: 'outlined',
  fullWidth: true,
  fontSize: '1rem'
};
